import React, { useEffect, useMemo, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import axios from "axios";
import _, { parseInt } from "lodash";
import { v4 as uuidv4 } from "uuid";

// component
import { errorSwal, successSwal } from "../../../helper/sweetalert";
import { COLOR_WHITE, LINEAR_GRADIENT_BG, S3_URL, SHOP_SETTING_KEY, USER_KEY } from "../../../const";

//apollo
import {
  GET_PRODUCT_GENBARCODE,
  GET_PRODUCTS,
} from "../../../apollo/product/query";
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import {
  CREATE_PRODUCT_VARIANT,
  CREATE_PRODUCT_VARIANT_MANY,
} from "../../../apollo/productVariant/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_SUVIVALS, GET_UNITS } from "../../../apollo/unit/Query";
import { GET_ATTRIBUTES } from "../../../apollo/attribute/query";
import { GET_ATTRIBUTEVALUES } from "../../../apollo/attributeValue/query";

// icons
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

// react bootrap
import { Col, Form, InputGroup, Row, Button, Spinner } from "react-bootstrap";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import useWindowDimensions from "../../../helper/windowDimensions";
import { ReactIcons } from "../../../icons";

function AddProductOption() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const historys = useHistory();
  const [unit, setUnit] = useState();
  const [history, setHistory] = useState([]);
  const [isChecked, setIsChecked] = useState(true);
  const [sortNumber, setSortNumber] = useState(0);
  const [selecteUnit, setSelectedUnit] = useState("");
  const [priceOptions, setPriceOptions] = useState([
    { price: 0, contain: "1", unit: "" },
  ]);
  const [genBarCode, setGenBarCode] = useState("");
  const [barcode, setBarCode] = useState("");
  const [nextBarcodeNumber, setNextBarcodeNumber] = useState(null);
  const [copyData, setCopyData] = useState({
    name: "",
    priceOptions: [{}],
    amount: "",
    originPrice: "",
    cfMessage: "",
    currency: "",
    detail: "",
    barCode: "",
    image: "",
    shippingCost: 0,
    isUsingSalePage: false,
  });
  const [files, setFiles] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [syncImagesByColor, setSyncImagesByColor] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(new Set());
  const { width } = useWindowDimensions();
  const [survivalDatas, setSurvivalDatas] = useState([]);
  const [selectSurvivalNumber, setSelectSurvivalNumber] = useState("");
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {};
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [commissionPlatforms, setCommissionPlatforms] = useState([
    { platform: "POS", commissionType: "FIXED", commissionValue: 0 },
    { platform: "ONLINE", commissionType: "FIXED", commissionValue: 0 },
  ]);
  const [
    selectedAttributeValueByAttributeId,
    setSelectedAttributeValueByAttributeId,
  ] = useState({});
  const [createMode, setCreateMode] = useState("single"); // "single" or "multiple"
  const [variantRows, setVariantRows] = useState([]);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [getUnit, { data: GetUnitData, loading: loadingUnit }] = useLazyQuery(
    GET_UNITS,
    { fetchPolicy: "network-only" },
  );

  const [getProducts, { data: productsData, loading: loadingProducts }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "cache-and-network" });

  const [getAttributes, { data: attributesData, loading: loadingAttributes }] =
    useLazyQuery(GET_ATTRIBUTES, { fetchPolicy: "cache-and-network" });

  const [
    getAttributeValues,
    { data: attributeValuesData, loading: loadingAttributeValues },
  ] = useLazyQuery(GET_ATTRIBUTEVALUES, { fetchPolicy: "cache-and-network" });

  const [
    LoadGenBarCode,
    { data: GetGenBarCodeData, loading: loadingGenBarCode },
  ] = useLazyQuery(GET_PRODUCT_GENBARCODE, { fetchPolicy: "network-only" });

  const [
    getSurvivalData,
    { loading: loadingSurvival, data: survivalDatasLoad, error },
  ] = useLazyQuery(GET_SUVIVALS, {
    fetchPolicy: "cache-and-network",
  });

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  const [createProductVariant, { loading: loadingCreate }] = useMutation(
    CREATE_PRODUCT_VARIANT,
  );

  const [createProductVariantMany, { loading: loadingCreateMany }] = useMutation(
    CREATE_PRODUCT_VARIANT_MANY,
  );

  // ============== > UseLazyQuery And UseMutaion <==============
  const handleClearForm = () => {
    setCopyData({
      name: "",
      priceOptions: [{}],
      amount: "",
      originPrice: "",
      cfMessage: "",
      currency: "",
      detail: "",
      barCode: "",
      image: "",
      shippingCost: 0,
      isUsingSalePage: false,
    });
    setFiles([]);
    setFileNames([]);
    setBarCode("");
    setGenBarCode("");
    setSelectedAttributeValueByAttributeId({});
    setCommissionPlatforms([
      { platform: "POS", commissionType: "FIXED", commissionValue: 0 },
      { platform: "ONLINE", commissionType: "FIXED", commissionValue: 0 },
    ]);
    if (isChecked) _loadGenBarCode();
  };

  useEffect(() => {
    _fecthUnit();
  }, []);

  useEffect(() => {
    if (!shopId) return;
    getProducts({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
          hasVariant: true,
        },
        orderBy: "createdAt_DESC",
        limit: 1000,
      },
    });
    getAttributes({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
        orderBy: "createdAt_DESC",
        limit: 1000,
      },
    });
    getAttributeValues({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
        orderBy: "createdAt_DESC",
        limit: 5000,
      },
    });
  }, [getProducts, getAttributes, getAttributeValues, shopId]);

  useEffect(() => {
    if (GetUnitData) setUnit(GetUnitData?.units?.data);
  }, [GetUnitData]);

  useEffect(() => {
    if (productsData) setProducts(productsData?.products?.data || []);
  }, [productsData]);

  useEffect(() => {
    if (GetGenBarCodeData) {
      const number = GetGenBarCodeData?.products?.total + 1;
      let _genBarCode = number;
      if (number <= 9) _genBarCode = "00000" + _genBarCode;
      else if (number <= 99) _genBarCode = "0000" + _genBarCode;
      else if (number <= 999) _genBarCode = "000" + _genBarCode;
      else if (number <= 9999) _genBarCode = "00" + _genBarCode;
      setGenBarCode(_genBarCode);
      setNextBarcodeNumber(number);
    }
  }, [GetGenBarCodeData]);

  useEffect(() => {
    if (isChecked) _loadGenBarCode();
  }, [isChecked]);



  // useEffect Hooks
  useEffect(() => {
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals) {
        fetchSurvivalDatas(locals.id);
      }
    }
  }, []);

  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);

  const attributes = useMemo(() => {
    const list = attributesData?.attributes?.data ?? [];
    return list
      .map((a) => ({ id: a?.id ?? "", name: (a?.name ?? "").trim() }))
      .filter((a) => a.id && a.name);
  }, [attributesData]);

  const attributeValues = useMemo(() => {
    const list = attributeValuesData?.attributeValues?.data ?? [];
    return list
      .map((v) => ({
        id: v?.id ?? "",
        value: (v?.value ?? "").trim(),
        attributeId: v?.attribute?.id ?? "",
        attributeName: (v?.attribute?.name ?? "").trim(),
      }))
      .filter((v) => v.id && v.value && v.attributeId);
  }, [attributeValuesData]);

  const attributeValuesByAttributeId = useMemo(() => {
    const map = new Map();
    for (const v of attributeValues) {
      if (!map.has(v.attributeId)) map.set(v.attributeId, []);
      map.get(v.attributeId).push(v);
    }
    for (const list of map.values())
      list.sort((a, b) => a.value.localeCompare(b.value));
    return map;
  }, [attributeValues]);

  const attributeValueById = useMemo(() => {
    const map = new Map();
    for (const v of attributeValues) map.set(v.id, v);
    return map;
  }, [attributeValues]);

  const selectedAttributeValueText = useMemo(() => {
    const parts = [];
    for (const a of attributes) {
      if (createMode === "single") {
        const selectedId = selectedAttributeValueByAttributeId[a.id];
        if (!selectedId) continue;
        const value = attributeValueById.get(selectedId)?.value;
        if (!value) continue;
        parts.push(`${a.name}: ${value}`);
      } else {
        const selectedIds = selectedAttributeValueByAttributeId[a.id] || [];
        if (!selectedIds.length) continue;
        const values = selectedIds
          .map((id) => attributeValueById.get(id)?.value)
          .filter(Boolean);
        if (!values.length) continue;
        parts.push(`${a.name}: ${values.join(", ")}`);
      }
    }
    return parts.join(" / ");
  }, [attributeValueById, attributes, selectedAttributeValueByAttributeId, createMode]);
  const buildCombinationKey = (combination) => combination.join("|");

  const buildCombinationLabel = useMemo(
    () => (combination) => {
      const parts = combination
        .map((id) => attributeValueById.get(id))
        .filter(Boolean)
        .map((item) => `${item.attributeName}: ${item.value}`);
      return parts.join(" / ");
    },
    [attributeValueById],
  );

  useEffect(() => {
    if (createMode !== "multiple") return;
    const combinations = generateCombinations(selectedAttributeValueByAttributeId);
    setVariantRows((prev) => {
      const prevMap = new Map(prev.map((row) => [row.key, row]));
      return combinations.map((combination) => {
        const key = buildCombinationKey(combination);
        const existing = prevMap.get(key);
        return {
          key,
          attributeValues: combination,
          label: buildCombinationLabel(combination),
          amount: existing?.amount ?? 0,
          price: existing?.price ?? 0,
          originPrice: existing?.originPrice ?? 0,
          barCode: existing?.barCode ?? "",
          autoBarcode: existing?.autoBarcode ?? true,
          imageNames: existing?.imageNames ?? [],
          imageFiles: existing?.imageFiles ?? [],
        };
      });
    });
  }, [buildCombinationLabel, createMode, selectedAttributeValueByAttributeId]);

  useEffect(() => {
    setSelectedRowKeys((prev) => {
      const validKeys = new Set(variantRows.map((row) => row.key));
      const next = new Set();
      for (const key of prev) {
        if (validKeys.has(key)) next.add(key);
      }
      return next;
    });
  }, [variantRows]);

  useEffect(() => {
    if (createMode !== "multiple") return;
    if (!genBarCode) return;
    setVariantRows((rows) => {
      let current =
        typeof nextBarcodeNumber === "number"
          ? nextBarcodeNumber
          : parseInt(genBarCode, 10) || 1;
      let changed = false;
      const nextRows = rows.map((row) => {
        if (row.autoBarcode && !row.barCode) {
          const code = formatBarcodeNumber(current);
          current += 1;
          changed = true;
          return { ...row, barCode: code };
        }
        return row;
      });
      if (changed) setNextBarcodeNumber(current);
      return nextRows;
    });
  }, [createMode, genBarCode, nextBarcodeNumber]);

  // ============== > fuctoions <==============
  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return; // Prevent re-triggering if already loading

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false,
          },
        },
      });
    } catch (err) {
      console.log("Load survival error: ", err);
    }
  };

  const _loadGenBarCode = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;

    await LoadGenBarCode({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  const _fecthUnit = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await getUnit({
      variables: {
        // limit: 500,
        where: {
          isDeleted: false,
          shop: shopId,
        },
      },
    });
  };

  // ============== > Helper function to generate combinations <==============
  const generateCombinations = (attributeSelections) => {
    const attributeIds = Object.keys(attributeSelections).filter(
      (attrId) => attributeSelections[attrId] && attributeSelections[attrId].length > 0
    );

    if (attributeIds.length === 0) return [[]];

    const combinations = [];

    const generate = (index, current) => {
      if (index === attributeIds.length) {
        combinations.push([...current]);
        return;
      }

      const attrId = attributeIds[index];
      const values = attributeSelections[attrId];

      for (const valueId of values) {
        current.push(valueId);
        generate(index + 1, current);
        current.pop();
      }
    };

    generate(0, []);
    return combinations;
  };

  // ============== > create product <==============

  const handleCreateProductNew = async (values) => {
    try {
      if (loadingCreate) return;
      const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data
        ?.shop?.id;
      const resolvedBarcode = isChecked ? genBarCode : barcode;

      const amount = parseFloat(
        values.amount ? values?.amount.toString().replace(/,/g, "") : 0,
      );
      const originPrice = parseFloat(
        values.originPrice
          ? values?.originPrice.toString().replace(/,/g, "")
          : 0,
      );
      const price = priceOptions.length > 0 ? priceOptions[0].price : 0;

      // Get selected attribute values as array (single mode)
      const attributeValues = Object.values(
        selectedAttributeValueByAttributeId,
      ).filter((id) => id && id.trim() !== "");

      let data = {
        product: selectedProductId,
        amount: parseInt(amount),
        attributeValues: attributeValues,
        price: price,
        originPrice: originPrice,
        cfMessage: values?.cfMessage,
        shop: shopId,
        currency: values.currency || "LAK",
        commissionPlatforms: commissionPlatforms.filter(
          (cp) => cp.commissionValue > 0,
        ),
        isUsingSalePage: values?.isUsingSalePage,
      };
      if (resolvedBarcode) {
        data = { ...data, barCode: resolvedBarcode };
      }

      // Add image if uploaded
      if (!_.isEmpty(fileNames)) {
        data = { ...data, image: fileNames };
      }

      await createProductVariant({
        variables: {
          data,
        },
      });
      const historyShowData = [
        ...history,
        { ...values, ...{ priceOptions: priceOptions } },
      ];
      setHistory(historyShowData);

      successSwal("ເພິ່ມສິນຄ້າສຳເລັດແລ້ວ!");
      setTimeout(() => {
        historys.push("/productlist/limit/50/page/1");
      }, 300);
    } catch (err) {
      if (err.message === "PRODUCT_ALREADY_EXIST")
        return errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      errorSwal("ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  const handleCreateProductVariantMany = async (values) => {
    try {
      if (loadingCreateMany) return;
      const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data
        ?.shop?.id;
      if (variantRows.length === 0) {
        return errorSwal("ກະລຸນາເລືອກ Attribute");
      }

      // Create data array for each combination
      const dataArray = variantRows.map((row) => {
        let data = {
          product: selectedProductId,
          amount: parseInt(row.amount),
          attributeValues: row.attributeValues,
          price: row.price,
          originPrice: row.originPrice,
          cfMessage: values?.cfMessage,
          shop: shopId,
          currency: values.currency || "LAK",
          commissionPlatforms: commissionPlatforms.filter(
            (cp) => cp.commissionValue > 0,
          ),
          isUsingSalePage: values?.isUsingSalePage,
        };
        if (row?.barCode) {
          data = { ...data, barCode: row.barCode };
        }

        // Add image if uploaded
        const imagesToUse = !_.isEmpty(row?.imageNames) ? row.imageNames : fileNames;
        if (!_.isEmpty(imagesToUse)) {
          data = { ...data, image: imagesToUse };
        }

        return data;
      });

      const result = await createProductVariantMany({
        variables: {
          data: dataArray,
        },
      });

      const resultData = result?.data?.createProductVariantMany;
      if (resultData?.status === true) {
        const total = resultData?.total || 0;
        successSwal(`ເພິ່ມສິນຄ້າສຳເລັດແລ້ວ ${total} ລາຍການ!`);
        setTimeout(() => {
          historys.push("/productlist/limit/50/page/1");
        }, 300);
      } else {
        errorSwal(resultData?.msg || "ເກີດຂໍ້ຜິດພາດ");
      }
    } catch (err) {
      console.error("Create many error:", err);
      errorSwal("ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  const ImageThumb = ({ image, style }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          borderRadius: 8,
          height: 300,
          width: 300,
          ...style,
        }}
      />
    );
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setFileNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSetCover = (index) => {
    if (index === 0) return;

    setFiles((prev) => {
      const newFiles = [...prev];
      const selected = newFiles.splice(index, 1)[0];
      newFiles.unshift(selected);
      return newFiles;
    });

    setFileNames((prev) => {
      const newFileNames = [...prev];
      const selected = newFileNames.splice(index, 1)[0];
      newFileNames.unshift(selected);
      return newFileNames;
    });
  };

  const handleUpload = async (event) => {
    setImageLoading(true);
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      setImageLoading(false);
      return;
    }

    try {
      for (const file of selectedFiles) {
        const ext = file.name.split(".").pop();
        const filename = uuidv4() + "." + ext;

        const res = await getPresignUrl({
          variables: {
            name: filename,
          },
        });

        const url = res?.data?.preSignedUrl?.url;
        if (url) {
          await axios.put(url, file, {
            headers: {
              "Content-Type": "file/*; image/*",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            },
          });
          setFiles((prev) => [...prev, file]);
          setFileNames((prev) => [...prev, filename]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleAddMorePrice = () => {
    const _newPriceOptions = [...priceOptions, { price: 0, contain: "" }];
    setPriceOptions(_newPriceOptions);
  };

  const _handleChangePrie = (value, i) => {
    // Create a new copy of the array with the updated element
    const newArray = [...priceOptions];
    // console.log("newArray: ", newArray)
    newArray[i] = {
      ...newArray[i],
      price: parseFloat(value.toString().replace(/,/g, "")),
    };
    // newArray[i] = parseFloat(value)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArray);
  };

  const _handleChangeContain = (valueContain, iContain) => {
    // Create a new copy of the array with the updated element
    const newArrayContain = [...priceOptions];
    newArrayContain[iContain] = {
      ...newArrayContain[iContain],
      contain: valueContain.toString(),
    };
    // newArray[i] = parseFloat(valueContain)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArrayContain);
  };

  const _handleChangeUnit = (valueUnit, iUnit) => {
    // Create a new copy of the array with the updated element
    const newArrayUnit = [...priceOptions];
    newArrayUnit[iUnit] = {
      ...newArrayUnit[iUnit],
      unit: valueUnit.toString(),
    };
    // newArray[i] = parseFloat(valueContain)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArrayUnit);
  };

  const handleDelete = (i) => {
    const deletVal = [...priceOptions];
    deletVal.splice(i, 1);
    setPriceOptions(deletVal);
  };

  const onCoppy = (his) => {
    setCopyData(his);
    setPriceOptions(his.priceOptions);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) _loadGenBarCode();
  };

  const handleChangAddbarCode = (event) => {
    setBarCode(event.target.value);
  };

  const handleCommissionChange = (index, field, value) => {
    const newCommissions = [...commissionPlatforms];
    if (field === "commissionValue") {
      newCommissions[index][field] =
        parseFloat(value.toString().replace(/,/g, "")) || 0;
    } else {
      newCommissions[index][field] = value;
    }
    setCommissionPlatforms(newCommissions);
  };

  const handleVariantRowChange = (rowKey, field, value) => {
    setVariantRows((prev) =>
      prev.map((row) => {
        if (row.key !== rowKey) return row;
        if (field === "barCode") {
          return { ...row, [field]: value };
        }
        const numericValue =
          field === "amount"
            ? parseInt(value.toString().replace(/,/g, "")) || 0
            : parseFloat(value.toString().replace(/,/g, "")) || 0;
        return { ...row, [field]: numericValue };
      }),
    );
  };

  const handleVariantRowAutoChange = (rowKey, checked) => {
    setVariantRows((prev) =>
      prev.map((row) =>
        row.key === rowKey ? { ...row, autoBarcode: checked } : row,
      ),
    );
    if (checked) {
      handleGenerateRowBarcode(rowKey);
    }
  };

  const formatBarcodeNumber = (number) => {
    let code = number;
    if (number <= 9) code = "00000" + code;
    else if (number <= 99) code = "0000" + code;
    else if (number <= 999) code = "000" + code;
    else if (number <= 9999) code = "00" + code;
    return String(code);
  };

  const handleGenerateRowBarcode = (rowKey) => {
    setNextBarcodeNumber((prev) => {
      const current =
        typeof prev === "number"
          ? prev
          : parseInt(genBarCode, 10) || 1;
      const newBarcode = formatBarcodeNumber(current);
      setVariantRows((rows) =>
        rows.map((row) =>
          row.key === rowKey ? { ...row, barCode: newBarcode } : row,
        ),
      );
      return current + 1;
    });
  };

  const handleBulkUpdateVariants = (field, value) => {
    const numericValue =
      field === "amount"
        ? parseInt(value.toString().replace(/,/g, "")) || 0
        : parseFloat(value.toString().replace(/,/g, "")) || 0;
    setVariantRows((prev) =>
      prev.map((row) => ({ ...row, [field]: numericValue })),
    );
  };

  const handleRowFileSelect = async (rowKey, event) => {
    setImageLoading(true);
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      setImageLoading(false);
      return;
    }

    try {
      const getRowColorValueId = (row) => {
        const colorValue = (row?.attributeValues || [])
          .map((id) => attributeValueById.get(id))
          .find((item) => {
            const name = (item?.attributeName || "").toLowerCase();
            return name.includes("color") || name.includes("ສີ");
          });
        return colorValue?.id || "";
      };
      const baseRow = variantRows.find((row) => row.key === rowKey);
      const baseColorValueId = baseRow ? getRowColorValueId(baseRow) : "";
      const targetRowKeys = new Set();
      if (syncImagesByColor && baseColorValueId) {
        variantRows.forEach((row) => {
          if (getRowColorValueId(row) === baseColorValueId) {
            targetRowKeys.add(row.key);
          }
        });
      } else if (selectedRowKeys.size > 0) {
        selectedRowKeys.forEach((key) => targetRowKeys.add(key));
      }
      targetRowKeys.add(rowKey);

      for (const file of selectedFiles) {
        const ext = file.name.split(".").pop();
        const filename = uuidv4() + "." + ext;

        const res = await getPresignUrl({
          variables: {
            name: filename,
          },
        });

        const url = res?.data?.preSignedUrl?.url;
        if (url) {
          await axios.put(url, file, {
            headers: {
              "Content-Type": "file/*; image/*",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            },
          });
          setVariantRows((prev) =>
            prev.map((row) =>
              targetRowKeys.has(row.key)
                ? {
                    ...row,
                    imageFiles: [...(row.imageFiles || []), file],
                    imageNames: [...(row.imageNames || []), filename],
                  }
                : row,
            ),
          );
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleRowRemoveFile = (rowKey, index) => {
    setVariantRows((prev) =>
      prev.map((row) =>
        row.key === rowKey
          ? {
              ...row,
              imageFiles: row.imageFiles.filter((_, i) => i !== index),
              imageNames: row.imageNames.filter((_, i) => i !== index),
            }
          : row,
      ),
    );
  };

  const handleRowSetCover = (rowKey, index) => {
    if (index === 0) return;
    setVariantRows((prev) =>
      prev.map((row) => {
        if (row.key !== rowKey) return row;
        const newFiles = [...row.imageFiles];
        const selectedFile = newFiles.splice(index, 1)[0];
        newFiles.unshift(selectedFile);

        const newNames = [...row.imageNames];
        const selectedName = newNames.splice(index, 1)[0];
        newNames.unshift(selectedName);

        return {
          ...row,
          imageFiles: newFiles,
          imageNames: newNames,
        };
      }),
    );
  };

  return (
    <>
      <BreadCrumbComponent
        goback={() => historys.goBack()}
        txtFirst="ສາງສິນຄ້າ"
        txtSecond={`ເພິ່ມສິນຄ້າ`}
      />

      <Formik
        enableReinitialize={true}
        initialValues={copyData}
        validate={(values) => {
          const errors = {};
          if (!selectedProductId) {
            errors.product = "ກະລຸນາເລືອກສິນຄ້າ!";
          }
          if (createMode === "single") {
            if (!values.amount) {
              errors.amount = "ກະລຸນາປ້ອນຈຳນວນກ່ອນ!";
            }
            if (priceOptions[0]?.price <= 0) {
              errors.priceOptions = "ກະລຸນາປອ້ນລາຄາຂາຍ!";
            }
          } else {
            if (variantRows.length === 0) {
              errors.variantRows = "ກະລຸນາເລືອກ Attribute";
            } else if (
              variantRows.some(
                (row) => Number(row.amount) <= 0 || Number(row.price) <= 0,
              )
            ) {
              errors.variantRows =
                "ກະລຸນາປ້ອນຈຳນວນ ແລະ ລາຄາໃຫ້ຄົບ";
            }
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          if (createMode === "single") {
            handleCreateProductNew(values);
          } else {
            handleCreateProductVariantMany(values);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              flexDirection: width > 700 ? "row" : "column",
              padding: 20,
            }}
          >
            {createMode === "single" && (
              <div
                style={{
                  width: width > 700 ? "35%" : "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "start",
                  padding: 10,
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <input
                    type="file"
                    id="file-upload"
                    onChange={handleUpload}
                    multiple
                    hidden
                  />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 10,
                      justifyContent: "center",
                    }}
                  >
                     {files.map((f, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          width: 150,
                          height: 150,
                          border: index === 0 ? "2px solid #3C169B" : "1px solid #E5E7EB",
                          borderRadius: 8,
                          overflow: "hidden",
                          cursor: index === 0 ? "default" : "pointer",
                        }}
                        onClick={() => handleSetCover(index)}
                      >
                        <ImageThumb
                          image={f}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            opacity: index === 0 ? 1 : 0.8,
                          }}
                        />
                        {index === 0 ? (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              background: "#3C169B",
                              color: "#fff",
                              padding: "2px 6px",
                              fontSize: 10,
                              borderBottomRightRadius: 8,
                              zIndex: 1,
                            }}
                          >
                            ພາບໜ້າປົກ
                          </div>
                        ) : (
                          <div
                            className="set-cover-overlay"
                            style={{
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              right: 0,
                              background: "rgba(0,0,0,0.5)",
                              color: "#fff",
                              fontSize: 10,
                              textAlign: "center",
                              padding: "2px 0",
                            }}
                          >
                            ຕັ້ງເປັນພາບໜ້າປົກ
                          </div>
                        )}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile(index);
                          }}
                          style={{
                            position: "absolute",
                            top: 5,
                            right: 5,
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            cursor: "pointer",
                            display: "flex",
                            padding: 2,
                            zIndex: 2,
                          }}
                        >
                          <ClearIcon style={{ fontSize: 16, color: "red" }} />
                        </div>
                      </div>
                    ))}

                    <label htmlFor="file-upload" style={{ margin: 0 }}>
                      <div
                        style={{
                          backgroundColor: "#F9FAFB",
                          height: files.length > 0 ? 150 : 300,
                          width: files.length > 0 ? 150 : 300,
                          border: "1px dashed #93989F",
                          borderRadius: 8,
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {imageLoading ? (
                          <>
                            <Spinner
                              animation="border"
                              variant="primary"
                              style={{ color: "#3C169B" }}
                            />
                            <p style={{ color: "#3C169B", marginTop: 10 }}>
                              ກຳລັງອັບໂຫລດ...
                            </p>
                          </>
                        ) : (
                          <>
                            <CloudUploadOutlinedIcon
                              sx={{
                                fontSize: files.length > 0 ? 30 : 50,
                                color: "#93989F",
                              }}
                            />
                            {files.length === 0 && (
                              <>
                                <p style={{ color: "#93989F" }}>ເພີ່ມຮູບສິນຄ້າ</p>
                                <p
                                  style={{
                                    color: "#3C169B",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Browse
                                </p>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </label>
                    {files.length > 1 && (
                      <p style={{ marginTop: 10, fontSize: 12, color: "#6B7280" }}>
                        ໝາຍເຫດ: ຄລິກທີ່ຮູບທີ່ຕ້ອງການເພື່ອເປັນຮູບປົກ
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div
              style={{
                width: "100%",
                background: COLOR_WHITE,
                padding: "2em",
                borderRadius: 4,
              }}
            >
              <Row>
                <Col className="col-6">
                  <Form.Label>ເລືອກສິນຄ້າ</Form.Label>
                  <Form.Select
                    name="product"
                    value={selectedProductId}
                    onChange={(e) => setSelectedProductId(e.target.value)}
                    style={{
                      border:
                        errors.product && touched.product && errors.product
                          ? "solid 1px red"
                          : "",
                    }}
                    disabled={loadingProducts}
                  >
                    <option value="">--ເລືອກສິນຄ້າ--</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.name}
                      </option>
                    ))}
                  </Form.Select>
                  <small style={{ color: "red" }}>{errors.product}</small>
                </Col>
                {createMode === "single" && (
                  <>
                    <Col className="col-3">
                      <Form.Label>ລະຫັດບຣາໂຄດ</Form.Label>
                      {isChecked ? (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleChangAddbarCode}
                          value={barcode}
                          placeholder="ID bar code..."
                          disabled
                        />
                      ) : (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleChangAddbarCode}
                          value={barcode}
                          placeholder="ເລກ ID barCode..."
                        />
                      )}
                    </Col>
                    <Col className="col-3">
                      <Form.Label>
                        {" "}
                        <Form.Check
                          aria-label="option 1"
                          value={isChecked}
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          label={`ໂອໂຕ ບຣາໂຄດ`}
                        />{" "}
                      </Form.Label>
                      <Form.Control
                        name="barcode"
                        aria-label="Default select example"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={genBarCode}
                        placeholder="ເລກ ID ສິ້ນຄ້າ..."
                        disabled
                      />
                    </Col>
                  </>
                )}
              </Row>
              <br />

              {/* ===== && ===== */}

              <Row className="mt-2">
                <Col className="col-12">
                  <Form.Label>ລະຫັດ CF</Form.Label>
                  <Form.Control
                    name="cfMessage"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.cfMessage}
                    placeholder="ປ້ອນ...."
                  />
                </Col>
              </Row>
              <br />

              {/* ===== && ===== */}
              <>
                <Row className="mt-2">
                  <Col className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Form.Label className="mb-0">ຄຸນລັກສະນະ</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          id="mode-single"
                          label="ເພີ່ມທີລະລາຍການ"
                          checked={createMode === "single"}
                          onChange={() => {
                            setCreateMode("single");
                            setSelectedAttributeValueByAttributeId({});
                          }}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          id="mode-multiple"
                          label="ເພີ່ມຫຼາຍລາຍການພ້ອມກັນ"
                          checked={createMode === "multiple"}
                      onChange={() => {
                            setCreateMode("multiple");
                            setSelectedAttributeValueByAttributeId({});
                            setVariantRows([]);
                        _loadGenBarCode();
                          }}
                        />
                      </div>
                    </div>

                    <Row className="mt-2 mb-3">
                        <Col className="col-12">
                          <Form.Check
                            type="switch"
                            id="is-using-sale-page-switch"
                            name="isUsingSalePage"
                            label="ເປີດຂາຍເທິງ SalePage"
                            checked={values.isUsingSalePage}
                            onChange={handleChange}
                          />
                        </Col>
                      </Row>
                      
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: 6,
                        padding: 12,
                        background: "#F9FAFB",
                      }}
                    >
                      <Row>
                        {attributes.length > 0 ? (
                          attributes.map((a) => {
                            const valuesForAttr =
                              attributeValuesByAttributeId.get(a.id) ?? [];
                            return (
                              <Col key={a.id} className="col-6 mt-2">
                                <Form.Label style={{ marginBottom: 6 }}>
                                  {a.name}
                                </Form.Label>
                                {createMode === "single" ? (
                                  <Form.Select
                                    value={
                                      selectedAttributeValueByAttributeId[a.id] ??
                                      ""
                                    }
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      setSelectedAttributeValueByAttributeId(
                                        (prev) => ({
                                          ...prev,
                                          [a.id]: selectedValue,
                                        }),
                                      );
                                    }}
                                    disabled={
                                      !shopId ||
                                      loadingAttributes ||
                                      loadingAttributeValues ||
                                      valuesForAttr.length === 0
                                    }
                                  >
                                    <option value="">-- ເລືອກ --</option>
                                    {valuesForAttr.map((v) => (
                                      <option key={v.id} value={v.id}>
                                        {v.value}
                                      </option>
                                    ))}
                                  </Form.Select>
                                ) : (
                                  <div
                                    style={{
                                      border: "1px solid #dee2e6",
                                      borderRadius: 6,
                                      padding: 8,
                                      background: "#fff",
                                      minHeight: "42px",
                                      maxHeight: "150px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {valuesForAttr.length === 0 ? (
                                      <div style={{ color: "#6c757d", fontSize: "14px" }}>
                                        ບໍ່ມີຂໍ້ມູນ
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "6px",
                                        }}
                                      >
                                        {valuesForAttr.map((v) => {
                                          const isChecked = (
                                            selectedAttributeValueByAttributeId[a.id] || []
                                          ).includes(v.id);
                                          return (
                                            <div
                                              key={v.id}
                                              onClick={() => {
                                                if (!shopId || loadingAttributes || loadingAttributeValues) return;
                                                const currentIds =
                                                  selectedAttributeValueByAttributeId[a.id] || [];
                                                const newIds = isChecked
                                                  ? currentIds.filter((id) => id !== v.id)
                                                  : [...currentIds, v.id];
                                                setSelectedAttributeValueByAttributeId(
                                                  (prev) => ({
                                                    ...prev,
                                                    [a.id]: newIds,
                                                  }),
                                                );
                                              }}
                                              style={{
                                                padding: "4px 10px",
                                                borderRadius: 4,
                                                cursor:
                                                  !shopId || loadingAttributes || loadingAttributeValues
                                                    ? "not-allowed"
                                                    : "pointer",
                                                fontSize: "13px",
                                                border: isChecked
                                                  ? "1px solid #3C169B"
                                                  : "1px solid #dee2e6",
                                                background: isChecked
                                                  ? "#3C169B"
                                                  : "#f8f9fa",
                                                color: isChecked ? "#fff" : "#495057",
                                                transition: "all 0.2s",
                                                userSelect: "none",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (!isChecked && !loadingAttributes && !loadingAttributeValues) {
                                                  e.currentTarget.style.borderColor = "#3C169B";
                                                  e.currentTarget.style.background = "#e9e4f5";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (!isChecked) {
                                                  e.currentTarget.style.borderColor = "#dee2e6";
                                                  e.currentTarget.style.background = "#f8f9fa";
                                                }
                                              }}
                                            >
                                              {v.value}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </Col>
                            );
                          })
                        ) : (
                          <Col className="col-12">
                            <div style={{ color: "#6B7280" }}>
                              {loadingAttributes || loadingAttributeValues
                                ? "ກຳລັງໂຫຼດ..."
                                : "ບໍ່ພົບ Attribute"}
                            </div>
                          </Col>
                        )}
                      </Row>

                      <div style={{ marginTop: 10 }}>
                        <Form.Label style={{ marginBottom: 6 }}>
                          ເລືອກແລ້ວ
                        </Form.Label>
                        <Form.Control
                          value={selectedAttributeValueText}
                          disabled
                          placeholder="-"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                {createMode === "single" && (
                  <>
                    <Row className="mt-2">
                      <Col className="col-3">
                        <Form.Label>ຈຳນວນ</Form.Label>
                        <NumericFormat
                          name="amount"
                          min={0}
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="....."
                          value={values.amount}
                          thousandSeparator={true}
                          prefix={""}
                        />
                        <small style={{ color: "red" }}>{errors.amount}</small>
                      </Col>
                      <Col className="col-3">
                        <Form.Label>ຄ່າຈັດສົ່ງ</Form.Label>
                        <NumericFormat
                          name="shippingCost"
                          min={0}
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="ຄ່າຈັດສົ່ງ....."
                          value={values.shippingCost}
                          thousandSeparator={true}
                          prefix={""}
                        />
                        <small style={{ color: "red" }}>
                          {errors.shippingCost}
                        </small>
                      </Col>
                      <Col>
                        <Form.Label>ຫົວໜ່ວຍ</Form.Label>
                        <Form.Select
                          name="unitId"
                          aria-label="Default select example"
                          onChange={(e) => setSelectedUnit(e.target.value)}
                          onBlur={handleBlur}
                          value={selecteUnit}
                        >
                          <option value="">--ເລືອກ--</option>
                          {unit?.map((units, keyunit) => (
                            <option key={keyunit} value={units?.id}>
                              {units?.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col>
                        <Form.Label>ລາຄາຕົ້ນທືນ</Form.Label>
                        <NumericFormat
                          name="originPrice"
                          min={0}
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="ລາຄາຊື້ສິນຄ້າ..."
                          value={values.originPrice}
                          thousandSeparator={true}
                          prefix={""}
                        />
                      </Col>
                      <Col>
                        <Form.Label>ສະກຸນເງີນ</Form.Label>
                        <Form.Select
                          name="currency"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.currency}
                          style={{
                            border:
                              errors.currency && touched.currency && errors.currency
                                ? "solid 1px red"
                                : "",
                          }}
                        >
                          <option value="">--ເລືອກ--</option>
                          <option value="LAK">ກີບ</option>
                          <option value="BAHT">ບາດ</option>
                          <option value="USD">ໂດລາ</option>
                        </Form.Select>
                        <span style={{ color: "red" }}>{errors.currency}</span>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      {priceOptions.map((price, i) => (
                        <React.Fragment key={i}>
                          <Form.Group>
                            <Row>
                              <Col>
                                <Form.Label>
                                  ລາຄາຂາຍ
                                  {i === 0
                                    ? ""
                                    : i === 1
                                      ? "2"
                                      : i === 2
                                        ? "3"
                                        : ""}
                                </Form.Label>
                                <InputGroup className="">
                                  <NumericFormat
                                    className="form-control"
                                    min={1}
                                    name="priceOptionsprice"
                                    value={price.price}
                                    thousandSeparator={true}
                                    onChange={(e) => {
                                      if (
                                        parseFloat(price.price) >= 999999999999999
                                      )
                                        return;
                                      _handleChangePrie(e.target.value, i);
                                    }}
                                    style={{
                                      border:
                                        errors.priceOptions &&
                                        touched.priceOptions &&
                                        errors.priceOptions
                                          ? "solid 1px red"
                                          : "",
                                    }}
                                    placeholder="ລາຄາຂາຍສິ້ນຄ້າ..."
                                  />
                                </InputGroup>
                                <small style={{ color: "red" }}>
                                  {errors.priceOptions}
                                </small>
                              </Col>
                              <Col>
                                {i >= 1 ? (
                                  <>
                                    <Form.Label>
                                      ລະບຸຈຳນວນສິນຄ້າຂອງລາຄາ{" "}
                                      {i === 0
                                        ? ""
                                        : i === 1
                                          ? "2"
                                          : i === 2
                                            ? "3"
                                            : ""}
                                    </Form.Label>
                                    <InputGroup className="mb-3">
                                      <Form.Control
                                        name="priceOptionsContain"
                                        placeholder="ປ້ອນ..."
                                        onBlur={handleBlur}
                                        value={price.contain}
                                        onChange={(e) => {
                                          _handleChangeContain(e.target.value, i);
                                        }}
                                      />
                                      {i === 0 ? (
                                        ""
                                      ) : (
                                        <InputGroup.Text
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleDelete(i)}
                                        >
                                          <ClearIcon />
                                        </InputGroup.Text>
                                      )}
                                    </InputGroup>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col>
                                {i >= 1 ? (
                                  <>
                                    <Form.Label>
                                      ຫົວໜວ່ຍຂອງລາຄາ{" "}
                                      {i === 0
                                        ? ""
                                        : i === 1
                                          ? "2"
                                          : i === 2
                                            ? "3"
                                            : ""}
                                    </Form.Label>
                                    <InputGroup className="mb-3">
                                      <Form.Select
                                        name="priceOptionsUnit"
                                        aria-label="Default select example"
                                        placeholder="ຫົວໝວ່ຍ..."
                                        onBlur={handleBlur}
                                        value={price.unit}
                                        onChange={(e) => {
                                          _handleChangeUnit(e.target.value, i);
                                        }}
                                      >
                                        <option value="">--ເລືອກ--</option>
                                        {unit?.map((units, keyunit) => (
                                          <option
                                            key={keyunit}
                                            value={units?.name}
                                          >
                                            {units?.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                      {i === 0 ? (
                                        ""
                                      ) : (
                                        <InputGroup.Text
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleDelete(i)}
                                        >
                                          <ClearIcon />
                                        </InputGroup.Text>
                                      )}
                                    </InputGroup>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </Form.Group>
                        </React.Fragment>
                      ))}
                      <Col sm={8}></Col>
                      {priceOptions?.length >= 3 ? (
                        ""
                      ) : (
                        <Col sm={4}>
                          <div className="mt-2 d-flex justify-content-end align-items-end w-100">
                            <Button
                              onClick={() => handleAddMorePrice()}
                              variant="outline-secondary"
                            >
                              <AddIcon />
                              ເພີ່ມລາຄາຂາຍ
                            </Button>
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Row className="mt-3">
                      <Col>
                        <Form.Label>ເລກຈັດລຽງສະແດງລຳດັບ</Form.Label>
                        <NumericFormat
                          name="containOptionThird"
                          min={0}
                          className="form-control"
                          onChange={(e) => setSortNumber(e.target.value)}
                          placeholder="ເລກຈັດລຽງ..."
                          value={sortNumber}
                          thousandSeparator={true}
                          prefix={""}
                        />
                      </Col>
                      <Col>
                        <Form.Label>ໝາຍເລກລອດ</Form.Label>
                        <Form.Select
                          onChange={(e) =>
                            setSelectSurvivalNumber(e?.target?.value)
                          }
                          value={selectSurvivalNumber}
                          aria-label="Default select example"
                        >
                          <option value="">--ເລືອກ--</option>
                          {survivalDatas.map((option, indexOption) => (
                            <option key={indexOption} value={option?.id}>
                              {option?.survivalNumber}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </>
                )}
              </>

              {/* Commission Platforms */}
              {commissionEnable && (
                <Row className="mt-3">
                  <Col xs={12}>
                    <Form.Label style={{ fontWeight: "bold" }}>
                      ຄ່າຄອມມິດຊັ່ນ (Commission)
                    </Form.Label>
                  </Col>
                  {commissionPlatforms.map((commission, index) => (
                    <React.Fragment key={index}>
                      <Col xs={12} md={4}>
                        <Form.Label>
                          {commission.platform === "POS" ? "POS" : "ONLINE"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={commission.platform}
                          disabled
                          style={{ backgroundColor: "#f0f0f0" }}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Label>ປະເພດ</Form.Label>
                        <Form.Select
                          value={commission.commissionType}
                          onChange={(e) =>
                            handleCommissionChange(
                              index,
                              "commissionType",
                              e.target.value,
                            )
                          }
                        >
                          <option value="FIXED">ຈຳນວນເງິນ (FIXED)</option>
                          <option value="PERCENT">
                            ເປີເຊັນ (PERCENT)
                          </option>
                        </Form.Select>
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Label>
                          ມູນຄ່າ
                          {commission.commissionType === "PERCENTAGE"
                            ? " (%)"
                            : ""}
                        </Form.Label>
                        <NumericFormat
                          className="form-control"
                          value={commission.commissionValue}
                          onChange={(e) =>
                            handleCommissionChange(
                              index,
                              "commissionValue",
                              e.target.value,
                            )
                          }
                          thousandSeparator={true}
                          placeholder="0"
                          min={0}
                        />
                      </Col>
                    </React.Fragment>
                  ))}
                </Row>
              )}

              {createMode === "multiple" && (
                <Row className="mt-3">
                  <Col xs={12}>
                    <Form.Label style={{ fontWeight: "bold" }}>
                      ລາຍການຕົວຢ່າງ ({variantRows.length} ລາຍການ)
                    </Form.Label>
                    {errors.variantRows && (
                      <div style={{ color: "red", marginBottom: 6 }}>
                        {errors.variantRows}
                      </div>
                    )}
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: 6,
                        padding: 12,
                        background: "#F9FAFB",
                      }}
                    >
                      {variantRows.length === 0 ? (
                        <div style={{ color: "#6B7280" }}>
                          ກະລຸນາເລືອກ Attribute ເພື່ອສ້າງລາຍການ
                        </div>
                      ) : (
                        <>
                          <Row className="mb-3 pb-3 border-bottom align-items-end">
                            <Col xs={12} md={4}>
                              <Form.Label style={{ color: "#2563EB", fontWeight: "bold" }}>ປ້ອນຈຳນວນທັງໝົດ</Form.Label>
                              <NumericFormat
                                className="form-control"
                                placeholder="0"
                                thousandSeparator={true}
                                onValueChange={(values) => handleBulkUpdateVariants("amount", values.value)}
                              />
                            </Col>
                            <Col xs={12} md={4}>
                              <Form.Label style={{ color: "#2563EB", fontWeight: "bold" }}>ປ້ອນລາຄາທັງໝົດ</Form.Label>
                              <NumericFormat
                                className="form-control"
                                placeholder="0"
                                thousandSeparator={true}
                                onValueChange={(values) => handleBulkUpdateVariants("price", values.value)}
                              />
                            </Col>
                            <Col xs={12} md={4}>
                              <Form.Label style={{ color: "#2563EB", fontWeight: "bold" }}>ປ້ອນຕົ້ນທຶນທັງໝົດ</Form.Label>
                              <NumericFormat
                                className="form-control"
                                placeholder="0"
                                thousandSeparator={true}
                                onValueChange={(values) => handleBulkUpdateVariants("originPrice", values.value)}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3 align-items-center">
                            <Col xs={12} md={6}>
                              <Form.Check
                                type="switch"
                                id="sync-images-by-color"
                                label="ເພີ່ມຮູບໃຫ້ທຸກໄຊ້ທີ່ສີດຽວກັນ"
                                checked={syncImagesByColor}
                                onChange={(e) => setSyncImagesByColor(e.target.checked)}
                              />
                            </Col>
                            <Col xs={12} md={6} className="d-flex justify-content-end gap-2">
                              <Button
                                variant="outline-secondary"
                                onClick={() =>
                                  setSelectedRowKeys(new Set(variantRows.map((row) => row.key)))
                                }
                              >
                                ເລືອກທັງໝົດ
                              </Button>
                              <Button
                                variant="outline-secondary"
                                onClick={() => setSelectedRowKeys(new Set())}
                              >
                                ລ້າງການເລືອກ
                              </Button>
                            </Col>
                          </Row>
                          <Row>
                            {variantRows.map((row) => (
                              <React.Fragment key={row.key}>
                                <Col xs={12} md={4}>
                                  <Form.Label className="d-flex justify-content-between align-items-center">
                                    <span>ສີ / ໄຊ້</span>
                                    <Form.Check
                                      type="checkbox"
                                      label="ເລືອກ"
                                      checked={selectedRowKeys.has(row.key)}
                                      onChange={(e) =>
                                        setSelectedRowKeys((prev) => {
                                          const next = new Set(prev);
                                          if (e.target.checked) next.add(row.key);
                                          else next.delete(row.key);
                                          return next;
                                        })
                                      }
                                    />
                                  </Form.Label>
                                  <Form.Control value={row.label} disabled />
                                  <div style={{ marginTop: 8 }}>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
                                      {row?.imageFiles?.map((f, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            position: "relative",
                                            width: 60,
                                            height: 60,
                                            border: index === 0 ? "2px solid #3C169B" : "1px solid #E5E7EB",
                                            borderRadius: 4,
                                            overflow: "hidden",
                                            cursor: index === 0 ? "default" : "pointer",
                                          }}
                                          onClick={() => handleRowSetCover(row.key, index)}
                                        >
                                          <ImageThumb
                                            image={f}
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          />
                                          {index === 0 && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                background: "#3C169B",
                                                color: "#fff",
                                                padding: "1px 4px",
                                                fontSize: 8,
                                                borderBottomRightRadius: 4,
                                              }}
                                            >
                                              ໜ້າປົກ
                                            </div>
                                          )}
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleRowRemoveFile(row.key, index);
                                            }}
                                            style={{
                                              position: "absolute",
                                              top: 2,
                                              right: 2,
                                              background: "rgba(255, 255, 255, 0.8)",
                                              borderRadius: "50%",
                                              cursor: "pointer",
                                              display: f ? "flex" : "none",
                                            }}
                                          >
                                            <ClearIcon style={{ fontSize: 12, color: "red" }} />
                                          </div>
                                        </div>
                                      ))}
                                      <label htmlFor={`row-file-${row.key}`} style={{ margin: 0 }}>
                                        <div
                                          style={{
                                            width: 60,
                                            height: 60,
                                            border: "1px dashed #93989F",
                                            borderRadius: 4,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            background: "#fff",
                                          }}
                                        >
                                          <AddIcon style={{ fontSize: 20, color: "#93989F" }} />
                                        </div>
                                      </label>
                                    </div>
                                    <input
                                      type="file"
                                      id={`row-file-${row.key}`}
                                      onChange={(e) => handleRowFileSelect(row.key, e)}
                                      multiple
                                      hidden
                                    />
                                    {row?.imageFiles?.length > 1 && (
                                      <p style={{ marginTop: 4, fontSize: 10, color: "#6B7280" }}>
                                        ໝາຍເຫດ: ຄລິກທີ່ຮູບທີ່ຕ້ອງການເພື່ອເປັນຮູບປົກ
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col xs={12} md={2}>
                                  <Form.Label>ຈຳນວນ</Form.Label>
                                  <NumericFormat
                                    className="form-control"
                                    value={row.amount}
                                    thousandSeparator={true}
                                    min={0}
                                    onValueChange={(values) =>
                                      handleVariantRowChange(
                                        row.key,
                                        "amount",
                                        values.value,
                                      )
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={2}>
                                  <Form.Label>ລາຄາ</Form.Label>
                                  <NumericFormat
                                    className="form-control"
                                    value={row.price}
                                    thousandSeparator={true}
                                    min={0}
                                    onValueChange={(values) =>
                                      handleVariantRowChange(
                                        row.key,
                                        "price",
                                        values.value,
                                      )
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={2}>
                                  <Form.Label>ຕົ້ນທຶນ</Form.Label>
                                  <NumericFormat
                                    className="form-control"
                                    value={row.originPrice}
                                    thousandSeparator={true}
                                    min={0}
                                    onValueChange={(values) =>
                                      handleVariantRowChange(
                                        row.key,
                                        "originPrice",
                                        values.value,
                                      )
                                    }
                                  />
                                </Col>
                                <Col xs={12} md={2}>
                                  <Form.Label className="d-flex justify-content-between align-items-center">
                                    <span>ລະຫັດບຣາໂຄດ</span>
                                    <Form.Check
                                      type="checkbox"
                                      label="ໂອໂຕ"
                                      checked={row.autoBarcode || false}
                                      onChange={(e) =>
                                        handleVariantRowAutoChange(
                                          row.key,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      value={row.barCode || ""}
                                      placeholder="ເລກ ID barCode..."
                                      disabled={row.autoBarcode}
                                      onChange={(e) =>
                                        handleVariantRowChange(
                                          row.key,
                                          "barCode",
                                          e.target.value,
                                        )
                                      }
                                    />
                                    <Button
                                      variant="outline-secondary"
                                      disabled={loadingGenBarCode}
                                      onClick={() => handleGenerateRowBarcode(row.key)}
                                    >
                                      ສ້າງ
                                    </Button>
                                  </InputGroup>
                                </Col>
                              </React.Fragment>
                            ))}
                          </Row>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              )}

              <Row>
                <Col>
                  <Form.Group
                    className="mb-3 mt-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>ລາຍລະອຽດເພີ່ມເຕີ່ມ (ຖ້າມີ)</Form.Label>
                    <Form.Control
                      name="detail"
                      as="textarea"
                      placeholder="ປ້ອນ..."
                      rows={3}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.detail}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "end", gap: 5 }}>
                <Button variant="outline-secondary" className="px-4">
                  {" "}
                  <ReactIcons.MdCancel /> ຍົກເລີກ
                </Button>
                <Button
                  variant="light"
                  onClick={() => handleSubmit()}
                  className="px-4"
                  disabled={loadingCreate || loadingCreateMany}
                  style={{
                    background: LINEAR_GRADIENT_BG,
                    color: COLOR_WHITE,
                    border: "none",
                  }}
                >
                  {" "}
                  <ReactIcons.FaCheckCircle /> {loadingCreate || loadingCreateMany ? "ກຳລັງບັນທືກ..." : "ບັນທືກ"}
                </Button>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
}

export default AddProductOption;
